import { Spin } from "antd";

const Loading = () => {
  return (
    <div className="w-100 flex-center">
      <Spin />
    </div>
  );
};

export default Loading;
